import { ProfileRepository } from 'src/repositories'
import { ProfileEntity } from 'src/types'
import { useUpdateProfileNameMutation } from 'src/types/generated'

type LoadIsAssignProjectInput = {
  profile: ProfileEntity
  projectId: string
}

type SaveEmailInput = {
  email: string
  emailExpiresAt: Date | null
}

export const useProfile = () => {
  const [updateProfileNameMutation] = useUpdateProfileNameMutation()
  const updateProfileName = async (updatedName: string) => {
    await updateProfileNameMutation({ variables: { input: updatedName } })
  }

  const loadIsAssignProject = ({ profile, projectId }: LoadIsAssignProjectInput): boolean => {
    return profile.projects.some(assignedProject => assignedProject.id === projectId)
  }

  const saveEmail = async ({ email, emailExpiresAt }: SaveEmailInput) => {
    await ProfileRepository.saveEmail({ email, emailExpiresAt })
  }

  return {
    updateProfileName,
    loadIsAssignProject,
    saveEmail,
  }
}
